function mobileChecker(mobile: string): boolean {
  const mobileRgx = /^(\+98|0)( |-){0,1}\d{3}( |-){0,1}\d{3}( |-){0,1}\d{4}$/;
  return mobileRgx.test(mobile);
}
export { mobileChecker };
